/* @type { Styles } */

export const styles = {
  root: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  description: {
    marginBottom: 2,
    marginTop: 1,
  },
  accessDeniedContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconContainer: {
    width: 60,
    height: 60,
    backgroundColor: 'gray.3',
    borderRadius: '50%',
    marginBottom: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    color: 'gray.40',
    marginLeft: 0.5,
    marginTop: 0.5,
  },
}
